//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import goConsultant from '@/common/mixins/goConsultant'
import cardMixin from '../mixin/card'

export default {
    mixins: [
        goConsultant,
        cardMixin
    ],
    components: {
    },
    props: {
        consultant: Object,
        from: String,
        layout_id: [Number, String],
        index: [Number, String],
        force_phone_auth: Boolean,
        building_id: [Number, String]
    }
}
